module.exports = __webpack_public_path__ + "img/develco.f421d7f1.png";